import styled from 'styled-components';

// Which pair of a two-pair ("Both") sale a frame / measures step is for.
const PairBanner = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.8rem;
  border-radius: 999px;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  color: #3730a3;
  font-size: 0.85rem;
  font-weight: 700;
  white-space: nowrap;
`;

export default PairBanner;
